import { useQuery } from "react-query"
import { getAppointmentPendingsStatisticCardsData } from "api/Pendings";


export const useAppointmentPendingStatisticCardsData = () => {
    return useQuery<Array<any> | any>(
      ['appointmentPending'],
        () => getAppointmentPendingsStatisticCardsData(),
        {
            onError(error: any) {
                console.error(error)
            }
        }
    )
}